<ng-container>
  <div class="preview-search">
    <mat-icon
      class="material-symbols-outlined"
      class="manage_search"
      (click)="requestPreview()"
    >
      manage_search
    </mat-icon>
  </div>
</ng-container>
<div></div>
